import type { HistoryItem } from '../MatchmakingHistoryPopover';
import { HistoryItemButton } from './HistoryItemButton';

type HistorySectionProps = {
  title: string;
  items: HistoryItem[];
  onSelectHistory: (item: HistoryItem) => void;
  onClose: () => void;
};

export const HistorySection = ({
  title,
  items,
  onSelectHistory,
  onClose,
}: HistorySectionProps) => {
  if (items.length === 0) return null;

  return (
    <div>
      <h4 className="font-termina text-sm font-semibold text-[#111827] mb-3 uppercase tracking-wide">
        {title}
      </h4>
      <div className="space-y-2">
        {items.map((item) => (
          <HistoryItemButton
            key={item.searchId}
            item={item}
            onSelect={onSelectHistory}
            onClose={onClose}
          />
        ))}
      </div>
    </div>
  );
};

